import { render, staticRenderFns } from "./externalDetail.vue?vue&type=template&id=8130e49e"
import script from "./externalDetail.vue?vue&type=script&lang=js"
export * from "./externalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports